export default __webpack_public_path__ + "static/media/fastclix_lancets@2x.498444a0.png";